import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import NotificationService from "../../services/Notification";
import UserDataService from "../../services/User";
import { SelectNotificationModal } from "./SelectNotificationModal";
import { MultiSelect } from "react-multi-select-component";
export const UserGroupModel = ({ isOpen, onClose, category }: any) => {
  const { onOpen } = useDisclosure();
  const [corporates, setCorporates] = useState([
    {label:"Manoshala Team",value:"MANOSHALATEAM"},
    {label:"Bhumi",value:"BHUMIX01"},
    {label:"Jellyfish",value:"JELLY2D8"},
    {label:"Periferry",value:"PERIFERRY"},
    {label:"Periferry06",value:"PERIFERRY06"},
    {label:"Unominda",value:"ManoSXUno"},
    {label:"Credences",value:"CredXMano"}
  ]);
  const [selectedCorporates, setSelectedCorporates] = useState<any>([]);
  const [level, setLevel] = useState<any>("");
  const [modal, setModal] = useState("");
  const [subLevel, setSubLevel] = useState<any>("");
  const [target, setTarget] = useState<any>("");
  const [ids, setIds] = useState<any>([]);
  const getTargetName = () => {
    let targetName = level;
    if(selectedCorporates.length>0){
      const formattedCorporates:any[] = selectedCorporates.map((el: any) => el.value);

      targetName = formattedCorporates.join(",");
    } 
    if (subLevel) {
      targetName += `- ${subLevel}`;
    }
    setTarget(targetName);
  };
  const handleSubmit = async () => {

    if (level || selectedCorporates.length>0) {
      const testids = [
        "8merwrSzZjRS9fEZWhmVjLY6fuk2", // singhayush28321@gmail.com
        "mR4bL1kCOOQ4qKbK5rlNNuSXXmd2", // abhishek@manoshala.com
        "u1AJIUq2hbYtGvIu04AgSbPGRiD2", // abhisheksw4@gmail.com
        "wdUXzFuNwVOwPOEPuMypvakfrxE2", // kratika@manoshala.com
        "LBtD4WltjQd7Z6G8tENOJDwMiK02", // kratikaagarwal1@gmail.com
        "9RG0vgUnqwa6sAxjAunY6p8HHeW2", // nish1997ns@gmail.com
        "3QFuBpAtj9XNespGO80hEJRxB9g2", // amitkumarkvpgi@gmail.com
      ]

      if(selectedCorporates.length>0){
        await Promise.all(selectedCorporates.map(async (el:any)=>{
          const res = await  UserDataService.getUserIdsByLevel(level, subLevel,el.value);
          const userIds = res.data;
          setIds([...userIds, ...ids]);
        }))

        setIds([ ...ids,...testids]);
      }
      else{

        UserDataService.getUserIdsByLevel(level, subLevel,"")
          .then((res: any) => {
            setIds([...res.data, ...testids]);
  
      
          })
          .catch((error: any) => {
            console.log(error);
          });
      }

      getTargetName();
      setModal("NotificationModal");
      onOpen();
    }
  };
  const closeModal = () => {
    clearState();
    onClose();
  };
  const clearState = () => {
    setModal("");
    setLevel("");
    setSubLevel("");
    setIds([]);
    // onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Choose group to send notification</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel htmlFor="level-select">Select level</FormLabel>
            <Select
              name=""
              id="level-select"
              onChange={(e) => setLevel(e.target.value)}
            >
              <option value="">Select level</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </Select>
          </FormControl>
          <FormControl mt={"25px"}>
            <FormLabel htmlFor="sub-level-select">Select Sub Level</FormLabel>
            <Select
              name=""
              id="sub-level-select"
              onChange={(e) => setSubLevel(e.target.value)}
            >
              <option value="">Select Sub Level</option>
              <option value="hope">Hope Chatbot</option>
              <option value="match_my_therapist">Match My Therapist</option>
              <option value="assessment">Assessment</option>
              <option value="other">Other</option>
            </Select>
          </FormControl>

          <FormControl mt={"25px"}>
            <FormLabel htmlFor="corporate-select">Select Corporates</FormLabel>
            <MultiSelect
            options={corporates}
            labelledBy="Select"
            value={selectedCorporates}
            onChange={setSelectedCorporates}
          />
          </FormControl>

        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={handleSubmit}
          >
            Next
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={closeModal}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
      {modal === "NotificationModal" && (
        <SelectNotificationModal
          isOpen={isOpen}
          onClose={closeModal}
          category={category}
          ids={ids}
          target={target}
        />
      )}
    </Modal>
  );
};
